import type { BundlerResult } from './BundlerResult.js';

/**
 * Final bundle result as returned by `bundle()` in `@ms-cloudpack/bundler`.
 */
// rawInput and rawOutput are intentionally removed.
// rebuild is wrapped to return a full BundleResult.
export interface BundleResult extends Omit<BundlerResult, 'rebuild' | 'rawInput' | 'rawOutput'> {
  /**
   * The name of the bundler used. Will be set unless there was an error with the options.
   */
  bundler?: string;

  /**
   * The version of the bundler used. Will be set unless there was an error with the options.
   */
  bundlerVersion?: string;

  /**
   * @deprecated Replaced by `bundler`.
   *
   * This and the translation code in `readResultFromCache` should be removed sometime when
   * we have to bump the hash version.
   */
  bundlerName?: string;

  /**
   * The absolute input path of the entries.
   */
  inputPath: string;

  /**
   * The entry file paths map used to create the bundle output. See `BundleOptions.entries`.
   */
  entries?: Record<string, string>;

  /**
   * If incremental bundling is specified, provide a way to rebuild the project.
   */
  rebuild?: () => Promise<BundleResult>;
}
